import { createClient } from '@lumi.new/sdk'

export const lumi = createClient({
  projectId: 'p382402333013508096',
  apiBaseUrl: 'https://api.lumi.new',
  authOrigin: 'https://auth.lumi.new',
})
